import { Dialog } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { HighlightOffOutlined } from '@mui/icons-material';
import PopSelectMultiImages from "./PopSelectMultiImages";
import ConnUrls from "../../../MyConns/Connections/ConnectURL";
import { CurrentSingleContext } from "../../MyContexts/CurrentSingle_Context";


///בחירת תמונה
const SelectGalleryComp = (props) => {

    const [diag, setDiag] = useState("");
    const [sliderImges, setSliderImges] = useState(props.listImges || []);
    const [dispSliderImges, setDispSliderImges] = useState();

    useEffect(() => {
        SettingSliderImges();

    }, [sliderImges, props.listImges])



    const selectSliderImgs = (listImges, theFunction) => {
        setDiag(
            <Dialog onClose={() => setDiag()} open={true} className={"popUpWrapMedia"}>
                <div className={"inDiag"}>
                    <HighlightOffOutlined sx={{ fontSize: 40 }}
                        className={"pointing closeDiagBtn"} onClick={() => setDiag()} />
                    <PopSelectMultiImages imgsList={listImges} handleClose={() => setDiag()}
                        imagesArray=
                        {(urlsList) => {
                            theFunction(urlsList);
                            setSliderImges(urlsList || []);
                            setDiag();
                        }} />

                </div>
            </Dialog>
        )

    };




    const SettingSliderImges = () => {
        {
            let bk = "";
            if (props.listImges.length > 0) {
                bk = props.listImges.map((item, index) => {
                    return (
                        <div key={index} className={"sldGalItm"}>
                            <div className={"mediumImgDisp pointing"}>
                                <HighlightOffOutlined sx={{ fontSize: 20 }}
                                    className={"removeOnImages"}
                                    onClick={() => { removeThisFromGall(index) }} />
                                <img src={item.img} />
                            </div>
                        </div>
                    )
                })
            }

            setDispSliderImges(bk);
        }
    }

    const removeThisFromGall = (index) => {
        let temp = [...props.listImges];
        temp.splice(index, 1);

        props.theFunction(temp);
        setSliderImges(temp);
    }

    return (
        <>
            <div className={"input-group"} id={`imgGall${props.indx}`}>
                <div className={"sldGalItm"} onClick={() => selectSliderImgs(sliderImges ? sliderImges : [], props.theFunction)} >
                    <img className={"mediumImgDisp pointing"}
                        src={ConnUrls.mediasLocalUrl + "/PermanentImages/AddImageBlk.png"} />
                </div>
                {dispSliderImges}
                {diag}

            </div>
        </>
    )
}

export default SelectGalleryComp;